import React from 'react';

const Vue_VSlot = () => {
  return (
    <div>
      <h1>Vue_VSlot Component</h1>
      <p>This is the Vue_VSlot tutorial page.</p>
    </div>
  );
}

export default Vue_VSlot;
